import React from 'react'

import Logo from './logo'
import { Link } from '../link/link.tsx'
import tideeLogo from '../../assets/img/tidee-logo.png'

type TMainLogo = {
    link: string
}

const MainLogo = ({ link }: TMainLogo) => {
    return (
        <Link to={link} display="flex" padding="30px 0 20px 0">
            <img
                alt="tidee"
                src={tideeLogo}
                width="100px"
                height="101px"
                style={{ marginRight: '20px' }}
            />
            <Logo align="center" bold size={89} />
        </Link>
    )
}

export default MainLogo
